export default "__VITE_ASSET__NXVG4GDG__"